import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { WidgetDate } from "@components/PreviewWidgets/WidgetDate";
import { WidgetImage } from "@components/PreviewWidgets/WidgetImage";
import { WidgetTime } from "@components/PreviewWidgets/WidgetTime";
import { WidgetWeather } from "@components/PreviewWidgets/WidgetWeather";

const Container = styled.div`
  position: absolute;
  width: ${({ width = "600" }) => width}px;
  height: ${({ height = "600" }) => height}px;
  top: ${({ y = "0" }) => y}px;
  left: ${({ x = "0" }) => x}px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${({ index = 1 }) => 1000 - index};
`;

export const WidgetItem = ({ widget, index }) => {
  const type = _.get(widget, ["type"]);
  const attribute = _.get(widget, ["attribute"]);
  const id = _.get(widget, ["id"]);
  const width = _.get(widget, ["width"]);
  const height = _.get(widget, ["height"]);
  const x = _.get(widget, ["position_x"]);
  const y = _.get(widget, ["position_y"]);

  return (
    <Container width={width} height={height} x={x} y={y}>
      {(() => {
        switch (type) {
          case "STATIC_IMAGE":
            return <WidgetImage key={id} attribute={attribute} />;
          case "STATIC_WEATHER":
            return <WidgetWeather key={id} />;
          case "STATIC_DATE":
            return <WidgetDate key={id} />;
          case "STATIC_TIME":
            return (
              <WidgetTime key={id} attribute={attribute} isPreview={false} />
            );
          default:
            return null;
        }
      })()}
    </Container>
  );
};
